/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Header_Shot_Description_TitlecaseInputs */

const en_ccsl_export_header_shot_description_titlecase = /** @type {(inputs: Ccsl_Export_Header_Shot_Description_TitlecaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shot Description`)
};

const fr_ccsl_export_header_shot_description_titlecase = /** @type {(inputs: Ccsl_Export_Header_Shot_Description_TitlecaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description du plan`)
};

const de_ccsl_export_header_shot_description_titlecase = /** @type {(inputs: Ccsl_Export_Header_Shot_Description_TitlecaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schussbeschreibung`)
};

const it_ccsl_export_header_shot_description_titlecase = /** @type {(inputs: Ccsl_Export_Header_Shot_Description_TitlecaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descrizione dello scatto`)
};

const ru_ccsl_export_header_shot_description_titlecase = /** @type {(inputs: Ccsl_Export_Header_Shot_Description_TitlecaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Описание кадра`)
};

const es_ccsl_export_header_shot_description_titlecase = /** @type {(inputs: Ccsl_Export_Header_Shot_Description_TitlecaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descripción de la toma`)
};

const zh_cn2_ccsl_export_header_shot_description_titlecase = /** @type {(inputs: Ccsl_Export_Header_Shot_Description_TitlecaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`镜头描述`)
};

const ja_ccsl_export_header_shot_description_titlecase = /** @type {(inputs: Ccsl_Export_Header_Shot_Description_TitlecaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ショットの説明`)
};

const hi_ccsl_export_header_shot_description_titlecase = /** @type {(inputs: Ccsl_Export_Header_Shot_Description_TitlecaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शॉट का विवरण`)
};

const pt_pt2_ccsl_export_header_shot_description_titlecase = /** @type {(inputs: Ccsl_Export_Header_Shot_Description_TitlecaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descrição da cena`)
};

/**
* | output |
* | --- |
* | "Shot Description" |
*
* @param {Ccsl_Export_Header_Shot_Description_TitlecaseInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_header_shot_description_titlecase = /** @type {((inputs?: Ccsl_Export_Header_Shot_Description_TitlecaseInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Header_Shot_Description_TitlecaseInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ccsl_export_header_shot_description_titlecase(inputs)
	if (locale === "de") return de_ccsl_export_header_shot_description_titlecase(inputs)
	if (locale === "it") return it_ccsl_export_header_shot_description_titlecase(inputs)
	if (locale === "ru") return ru_ccsl_export_header_shot_description_titlecase(inputs)
	if (locale === "es") return es_ccsl_export_header_shot_description_titlecase(inputs)
	if (locale === "zh-CN") return zh_cn2_ccsl_export_header_shot_description_titlecase(inputs)
	if (locale === "ja") return ja_ccsl_export_header_shot_description_titlecase(inputs)
	if (locale === "hi") return hi_ccsl_export_header_shot_description_titlecase(inputs)
	if (locale === "pt-PT") return pt_pt2_ccsl_export_header_shot_description_titlecase(inputs)
	return en_ccsl_export_header_shot_description_titlecase(inputs)
});